import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDnWX7n_fAZcS60ttLEjmqv1wnfXbuTFJg",
  authDomain: "delta-foods.firebaseapp.com",
  projectId: "delta-foods",
  storageBucket: "delta-foods.appspot.com",
  messagingSenderId: "1029536774286",
  appId: "1:1029536774286:web:2fe6d8cd15bba42c00b1df",
  measurementId: "G-061YN2308T",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const fireDB = getFirestore(app);

export default fireDB;
